module.exports = __webpack_public_path__ + "img/about_trinity.04945382.gif";